import { Create, SimpleForm, TextInput, useRedirect, useGetOne, SelectInput } from 'react-admin';
import { useState } from 'react';
import { useParams } from 'react-router-dom';

export const KeywordCreate = () => {

        return (
            <Create title='Add Api'>
                    <SimpleForm >
                    <TextInput label="Keyword" source="keyword" fullWidth />
                    <SelectInput fullWidth label="Status" source="status" choices={[
                        { id: '0', name: 'Inactive' },
                        { id: '1', name: 'Active' },
                    ]} />

                </SimpleForm>
            </Create>
    );

}